import { GET_AIRPORT, GET_AIRPORT_SUCESS, GET_AIRPORT_FAIL, MISSING_TOKEN, GET_REGION, GET_REGION_FAIL, GET_REGION_SUCESS } from './types';

export const getAirport = () => ({
    type: GET_AIRPORT
});

export const getAirportSucess = (data) => ({
    type: GET_AIRPORT_SUCESS,
    payload: { data }
});

export const getAirportFail = (error) => ({
    type: GET_AIRPORT_FAIL,
    payload: { error }
});

export const missingToken = () => ({
    type: MISSING_TOKEN
});

export const getRegion = () => ({
    type: GET_REGION
});

export const getRegionFail = error => ({
    type: GET_REGION_FAIL,
    payload: { error }
});

export const getRegionSucess = data => ({
    type: GET_REGION_SUCESS,
    payload: { data }
});